import React, { useState } from "react";
import { CalendarOutlined, FileTextOutlined } from "@ant-design/icons";
import VacationsScreen from "../VacationsScreen/VacationsScreen";
import ExcuseManagement from "../Excuse/ExcuseManagements";

const BRAND = "#1F6F7D";

const TABS = [
  { key: "vacations", label: "Vacations", icon: <CalendarOutlined />, children: <VacationsScreen /> },
  { key: "excuses", label: "Excuses", icon: <FileTextOutlined />, children: <ExcuseManagement /> },
];

export default function HumanResources() {
  const [activeKey, setActiveKey] = useState("vacations");

  return (
    <div className="min-h-screen bg-[#F7FCFD] overflow-x-hidden">
      {/* ── Tab bar ── */}
      <div className="px-2 pt-3 sm:px-6 sm:pt-6 md:px-8 md:pt-7">
        <div className="flex gap-1 overflow-x-auto">
          {TABS.map((tab) => {
            const isActive = activeKey === tab.key;
            return (
              <button
                key={tab.key}
                onClick={() => setActiveKey(tab.key)}
                className="flex-1 sm:flex-none flex items-center justify-center gap-2 px-3 sm:px-[22px] py-2.5 text-[13px] sm:text-sm font-bold whitespace-nowrap rounded-t-[10px] border-0 cursor-pointer transition-all"
                style={{
                  background: isActive ? "#fff" : "transparent",
                  color: isActive ? BRAND : "gray",
                  boxShadow: isActive ? "0 -2px 8px rgba(0,0,0,0.08)" : "none",
                }}
              >
                <span className="text-[15px]">{tab.icon}</span>
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* ── Tab content (all kept mounted so each tab keeps its state) ── */}
      <div>
        {TABS.map((tab) => (
          <div
            key={tab.key}
            style={{ display: activeKey === tab.key ? "block" : "none" }}
          >
            {tab.children}
          </div>
        ))}
      </div>
    </div>
  );
}